/* eslint-disable max-classes-per-file */
import { getText } from '../internal/TextLabels'

export class OrderModel {
  constructor() {
    this.newQuantity = null
    this.newQuantityValid = null
    this.reservedQuantityValid = null
  }
}

export class ChannelTypes {
  constructor() {
    this.labels = {}

    this.labels['MERCHANT_PORTAL'] = getText(
      'transactions.channelTypes.MerchantPortal',
    )
    this.labels['MERCHANT_API'] = getText(
      'transactions.channelTypes.MerchantApi',
    )
    this.labels['ECOMMERCE'] = getText('transactions.channelTypes.Ecom')
    this.labels['CHECKOUT_POS'] = getText(
      'transactions.channelTypes.CheckoutPos',
    )
  }
}

export class TransactionHeaders {
  constructor() {
    this.InvoiceHeaders = [
      {
        id: 'externalId',
        label: getText('transactions.headers.order'),
      },
      {
        id: 'created',
        label: getText('transactions.headers.date'),
        dataCy: 'created',
      },
      {
        id: 'governmentId',
        label: getText('transactions.headers.governmentId'),
        nonSortable: true,
      },
      {
        id: 'name',
        label: getText('transactions.headers.name'),
        nonSortable: true,
      },
      {
        id: 'channelType',
        label: getText('transactions.headers.channel'),
      },
      {
        id: 'invoiceNumber',
        label: getText('transactions.headers.invoiceNumber'),
      },
      {
        id: 'paymentMethod',
        label: getText('transactions.headers.method'),
      },
      {
        id: 'amount',
        type: 'number',
        label: getText('transactions.headers.amount'),
      },
      {
        id: 'application.status',
        label: getText('transactions.headers.status'),
        nonSortable: true,
      },
    ]
    this.Headers = [
      {
        id: 'externalId',
        label: getText('transactions.headers.order'),
      },
      {
        id: 'created',
        label: getText('transactions.headers.date'),
        dataCy: 'created',
      },
      {
        id: 'governmentId',
        label: getText('transactions.headers.governmentId'),
        nonSortable: true,
      },
      {
        id: 'name',
        label: getText('transactions.headers.name'),
        nonSortable: true,
      },
      {
        id: 'channelType',
        label: getText('transactions.headers.channel'),
      },
      {
        id: 'paymentMethod',
        label: getText('transactions.headers.method'),
      },
      {
        id: 'amount',
        type: 'number',
        label: getText('transactions.headers.amount'),
      },
      {
        id: 'application.status',
        label: getText('transactions.headers.status'),
        nonSortable: true,
      },
    ]
  }
}
